import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import immutable from 'object-path-immutable';

import Lights from 'components/lights/Lights';
import NextIcon from 'icons/NextIcon';

import {
  getDivisionDoc,
  getBestLift,
  getPlace,
  getSubtotal,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';
import {
  getCurrentMeet,
  getCurrentPlatform,
  getCurrentAttempt,
  getCurrentLifter
} from 'selectors';

import { getTotal } from '../../../util/lifterHelper';

const getGetOrdinal = (n) => {
  const s=['th', 'st', 'nd', 'rd'];
  const v = n%100;
  return <span>{n}<sup>{(s[(v-20)%10]||s[v]||s[0])}</sup></span>;
};

const AttemptCell = ({currentLifter, liftName, attemptNumber, currentAttemptNumber}) => {
  const attempt = _.get(currentLifter, ['lifts', liftName, attemptNumber]);
  const weight = _.get(attempt, 'weight', '');
  const result = _.get(attempt, 'result', '');
  return (
    <div className={classNames('platform-weight-cell', result, {'current-attempt': currentAttemptNumber === attemptNumber})} >{weight}</div>
  );
};


class Platform3 extends Component {

  getDecision = (position) => {
    const { meet, platform } = this.props;
    return _.get(meet, ['platforms', platform._id, 'refs', position, 'decision']);
  }

  allDecisionsMade = () => {
    return this.getDecision('left') && this.getDecision('head') && this.getDecision('right');
  }

  render() {
    const { meet, currentAttempt, platform, currentLifter } = this.props;
    if(!platform || !meet) {
      return null;
    }

    const lifterName = _.get(currentLifter, 'name', '------------------ -------------------');

    const liftName =  _.get(currentAttempt, 'liftName', '');
    let liftDisplayName =  _.capitalize(liftName);
    if(liftName === 'dead') {
      liftDisplayName = 'Deadlift';
    }
    const currentAttemptNumber = _.get(currentAttempt, 'attemptNumber', '0');
    let weightClassName = '---';
    let divisionName = '------------- ---------------- ----- ----';

    let subtotal = '000';
    let total = 0;

    const bestSquat = _.get(getBestLift('squat', currentLifter), 'weight', null);
    const bestBench = _.get(getBestLift('bench', currentLifter), 'weight', null);
    const bestDead = _.get(getBestLift('dead', currentLifter), 'weight', null);

    let totalDivisionCurrentPlace = 0;
    let totalDivisionForecastedPlace = 0;
    let totalLifterDivision;
    let divisionDoc;
    let fullMeetForecastedPlace = 1;

    if(currentLifter && currentAttempt) {
      totalLifterDivision = _.get(currentLifter, 'divisions.0');
      divisionDoc = getDivisionDoc(totalLifterDivision.divisionId, meet);
      const weightClassDoc = getLifterAwardsWeightClassDoc(meet, currentLifter, totalLifterDivision);
      weightClassName = _.get(weightClassDoc, 'name');
      divisionName = _.get(divisionDoc, 'name', "");

      if(weightClassName && _.size(divisionDoc.weightClasses) > 1) {
        divisionName = `${divisionName} - ${weightClassName}`;
      }

      // construct version of meet where the current attempt is sucessful.
      const futureMeet = immutable.set(meet, ['lifters', currentLifter._id, 'lifts', currentAttempt.liftName, currentAttempt.attemptNumber, 'result'], 'good');

      totalDivisionCurrentPlace = getPlace(currentLifter, totalLifterDivision, meet);
      totalDivisionForecastedPlace = getPlace(currentLifter, totalLifterDivision, futureMeet);
      fullMeetForecastedPlace = getPlace(currentLifter, totalLifterDivision, meet, true);

      subtotal = getSubtotal(currentLifter, meet);
      total = getTotal(currentLifter, totalLifterDivision.divisionId, meet);
    }

    const showPlaceChange = !!totalDivisionCurrentPlace && !!totalDivisionForecastedPlace;


    return (
      <div className="platform3">
        <div className={classNames("platform-lights", {"platform-lights-active": this.allDecisionsMade() || !currentLifter})}>
          <div className="platform-lights-wrapper"><Lights meet={meet} platformId={_.get(platform, '_id')} style={{height:70}} /></div>
        </div>
        <div className="platform-table">
          <div className={classNames("platform-current-name", {"long-name": lifterName.length > 21})}>
            <div>
              {lifterName}
              <div className={classNames("current-division", {"long-name": divisionName.length > 39})}>{divisionName}</div>
            </div>
          </div>

          <div className="platform-lift-name">
            {liftDisplayName}
          </div>
          <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'1'} currentAttemptNumber={currentAttemptNumber} />
          <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'2'} currentAttemptNumber={currentAttemptNumber} />
          <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'3'} currentAttemptNumber={currentAttemptNumber} />

          <div className="platform-best-lifts">
            <div className={classNames("platform-best-lift", {'platform-best-lift-missing': bestSquat === null})}>
              <span className="platform-best-lift-label">S</span> {bestSquat}
            </div>
            <div className={classNames("platform-best-lift", {'platform-best-lift-missing': bestBench === null})}>
              <span className="platform-best-lift-label">B</span> {bestBench}
            </div>
            <div className={classNames("platform-best-lift", {'platform-best-lift-missing': bestDead === null})}>
              <span className="platform-best-lift-label">D</span> {bestDead}
            </div>
          </div>
          <div className="platform-placements">
            <div className="platform-placement">
              <div className="platform-placement-name">
                {subtotal && !total && <span>Sub-Total</span>}
                {!!total && <span>Total</span>}
              </div>
              <div className="platform-placement-change">
                {subtotal && !total && <span>{subtotal}</span>}
                {!!total && <span>{total}</span>}
              </div>
            </div>
            <div className="platform-placement">
              <div className="platform-placement-name">
                { showPlaceChange ? 'Placement' : 'Forecasted' }
              </div>
              <div className="platform-placement-change">
                { showPlaceChange ?
                  <div>
                    {getGetOrdinal(totalDivisionCurrentPlace)} <NextIcon/> {getGetOrdinal(totalDivisionForecastedPlace)}
                  </div> : getGetOrdinal(fullMeetForecastedPlace)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    platform: getCurrentPlatform(state, props),
    currentAttempt: getCurrentAttempt(state, props),
    currentLifter: getCurrentLifter(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(Platform3));